import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentTasksService } from '@/pages/current-tasks/current-tasks.service';
import { MessageService } from 'primeng/api';
import { SpinnerComponent } from '@/components/shared/spinner/spinner.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'sm-dac-task-details',
  imports: [SpinnerComponent],
  template: '<sm-spinner [loading]="loading$"></sm-spinner>',
})
export class DacTaskDetailsComponent implements OnInit {
  private readonly currentTasksService = inject(CurrentTasksService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);

  loading$ = new BehaviorSubject<boolean>(true);
  taskId = this.activatedRoute.snapshot.params['taskId'];

  ngOnInit(): void {
    this.currentTasksService.getTaskDetailsDac(this.taskId).subscribe({
      next: dacDetails => {
        const dacId = dacDetails.dacDocs.dacId;
        const dacVer = dacDetails.dacDocs.dacVer;
        this.router.navigate([`/dac-create/${dacId}/${dacVer}`], { replaceUrl: true });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Une erreur est survenue lors de la récupération des détails de la tâche DAC',
        });
        this.loading$.next(false);
      },
    });
  }
}
